import type { PricingStrategy } from './pricing-strategy.js';
import {
  HourlyPerPersonStrategy,
  type HourlyPerPersonParams,
} from './strategies/hourly-per-person-strategy.js';
import {
  HourlyPerSeatStrategy,
  type HourlyPerSeatParams,
} from './strategies/hourly-per-seat-strategy.js';
import { FlatPerHourStrategy, type FlatPerHourParams } from './strategies/flat-per-hour-strategy.js';
import {
  TieredPerPersonStrategy,
  type TieredPerPersonParams,
} from './strategies/tiered-per-person-strategy.js';
import {
  PackageBlockStrategy,
  type PackageBlockParams,
} from './strategies/package-block-strategy.js';

/**
 * SSOT strategy registry. Adding a new strategy:
 *   1. Add type to `StrategyType` union in `pricing-strategy-type.ts`
 *   2. Write the strategy class in `strategies/`
 *   3. Add one branch here
 * Zero changes anywhere else (OCP).
 */

export type StrategyParams =
  | { type: 'hourly_per_person'; params: HourlyPerPersonParams }
  | { type: 'hourly_per_seat'; params: HourlyPerSeatParams }
  | { type: 'flat_per_hour'; params: FlatPerHourParams }
  | { type: 'tiered_per_person'; params: TieredPerPersonParams }
  | { type: 'package_block'; params: PackageBlockParams };

export function buildPricingStrategy(spec: StrategyParams): PricingStrategy {
  switch (spec.type) {
    case 'hourly_per_person':
      return new HourlyPerPersonStrategy(spec.params);
    case 'hourly_per_seat':
      return new HourlyPerSeatStrategy(spec.params);
    case 'flat_per_hour':
      return new FlatPerHourStrategy(spec.params);
    case 'tiered_per_person':
      return new TieredPerPersonStrategy(spec.params);
    case 'package_block':
      return new PackageBlockStrategy(spec.params);
  }
}

export type {
  HourlyPerPersonParams,
  HourlyPerSeatParams,
  FlatPerHourParams,
  TieredPerPersonParams,
  PackageBlockParams,
};
